import { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Typography,
  Button,
  IconButton,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Dialog,
  DialogHeader,
  DialogBody,
} from "@material-tailwind/react";
import CloseIcon from "@mui/icons-material/Close";
import { useMutation } from "react-query";
import FormBuilderEdit from "./FormBuilderEdit";
import { Link } from "react-router-dom";
import { RiInbox2Line } from "react-icons/ri";
import { httpMushPro } from "../../services/http-common";
import { toast } from "react-toastify";
import { formatDate } from "../../lib/util";
import FormBuilder from "./FormBuilder";
import { BsThreeDotsVertical } from "react-icons/bs";

const AllForms = () => {
  const [forms, setForms] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [showDetails, setShowDetails] = useState(false);

  const getAllForms = useMutation(
    () => {
      return httpMushPro.post("user/intake-form/get-all", {});
    },
    {
      onSuccess: ({ data }) => {
        setForms(data.records);
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  const deleteData = useMutation(
    (id) => {
      return httpMushPro.delete(`user/intake-form/delete?id=${id}`, null);
    },
    {
      onSuccess: () => {
        toast.success("Successfully Deleted");
        getAllForms.mutate();
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );

  const handleDelete = (id) => {
    deleteData.mutate(id);
  };
  const handleEdit = (form) => {
    setSelectedForm(form);
    setShowDetails(true);
  };

  const getUpdates = () => {
    getAllForms.mutate();
    setSelectedForm(null);
    handleOpen();
  };

  const handleOpen = () => {
    setShowDetails(!showDetails);
  };

  useEffect(() => {
    getAllForms.mutate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="mt-12 mb-8 flex flex-col gap-12">
        <div>
          <div className="flex justify-between items-center">
            <Typography variant="h4" color="blue-gray">
              Recent Intake Forms
            </Typography>
            <Link to="/intake-form/create">
              <Button
                size="sm"
                className="normal-case bg-[#000080] rounded-md hover:shadow-[inset_310px_0px_0px_#A52230]"
                onClick={handleOpen}
                style={{
                  background: "#000080",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: "20px",
                  lineHeight: "26px",
                  textDecoration: "none",
                  color: "#fff",
                  fontFamily: "'Outfit', sans-serif",
                  marginTop: "42px",
                }}
              >
                <i className="mdi mdi-plus mr-1"></i> Create New Form
              </Button>
            </Link>
          </div>
          <div className="mt-4 flex flex-col gap-4">
            {forms.length > 0 ? (
              forms.map((form) => (
                <Card className="mb-4" key={form.id}>
                  <CardBody>
                    <div className="flex justify-between">
                      <div>
                        <Typography
                          variant="h5"
                          color="blue-gray"
                          className="font-bold"
                        >
                          {form.title}
                        </Typography>
                        <Typography variant="small" color="gray">
                          {form.description}
                        </Typography>
                        <Typography variant="small" color="gray">
                          Updated: {formatDate(form.updated_at)}
                        </Typography>
                      </div>
                      <div className="flex items-center">
                        <div className="text-center mr-4">
                          <Typography variant="h6">
                            {form.formData.length}
                          </Typography>
                          <Typography variant="small" color="gray">
                            Questions
                          </Typography>
                        </div>
                        <Menu>
                          <MenuHandler>
                            <IconButton variant="text" color="blue-gray">
                              <BsThreeDotsVertical className="text-gray-600 text-xl" />
                            </IconButton>
                          </MenuHandler>
                          <MenuList>
                            <MenuItem onClick={() => handleEdit(form)}>
                              Edit
                            </MenuItem>
                            <MenuItem onClick={() => handleDelete(form.id)}>
                              Delete
                            </MenuItem>
                            <MenuItem>Share</MenuItem>
                          </MenuList>
                        </Menu>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              ))
            ) : (
              <div className="flex flex-col items-center mt-3 gap-2">
                <RiInbox2Line className="text-gray-600 text-xl" />
                <Typography color="gray">No Data</Typography>
              </div>
            )}
          </div>
        </div>
        <Dialog open={showDetails} onClose={handleOpen} size="lg">
          <DialogHeader className="flex justify-between items-center text-xl">
            <Typography variant="h6" color="blue-gray">
              Intake Form
            </Typography>
            <CloseIcon onClick={handleOpen} className="cursor-pointer" />
          </DialogHeader>
          <DialogBody>
            {selectedForm && (
              <FormBuilderEdit
                intakeForm={selectedForm}
                getUpdates={getUpdates}
              />
            )}
          </DialogBody>
        </Dialog>
      </div>
    </>
  );
};

export default AllForms;
